export function closeModalUsingState(closeValue, stateFunction)
{
    stateFunction(closeValue);
}